<script lang="ts" setup>
/* eslint-disable vue/no-v-html*/
import type { TabLink } from '~/components/tabs/Tabs.vue'
import { ApiCorporationProfile } from '~~/server/api/corporation/profile'

const { $t } = useNuxtApp()
const route = useRoute()
const { data: page, redirect } = await useFetchWithRedirect<ApiCorporationProfile>('/api/corporation/profile', { route })

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const pageLinks = computed<TabLink[]>((): TabLink[] => {
    if (!page.value) return []

    return page.value?.data.pages.map((page) => {
        return {
            name: page.title,
        }
    })
})
const breadcrumbs = computed<BreadcrumbsLink[]>((): BreadcrumbsLink[] => {
    return [
        {
            name: $t('O nás'),
            slug: {
                name: 'about',
            },
        },
    ]
})

// Schema.org
useSchemaOrg([
    defineWebPage({
        name: page.value?.data.title,
        description: useClearHtmlTags(page.value?.data.about_us.description!),
        sameAs: page.value?.data.social.data.map(
            (link: SocialsItem): string => link.url
        ),
    }),
])

usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})
</script>

<template>
  <article v-if="page">
    <ContainerFluid>
      <Breadcrumbs
        :current="page.data.title"
        :links="breadcrumbs"
      />

      <PageHeaderContent
        class="pt-12 pb-12 border-top"
        :tag="page.data.tag"
        :title="page.data.title"
        :subtitle="page.data.subtitle"
        text-color="black-100"
      />

      <PagesAboutProfileRatings
        :data="page.data.ratings"
        class="pb-12 pb-md-0 mb-md-20"
      />

      <PagesAboutProfileAboutUs
        :data="page.data.about_us"
        class="mb-20 mb-md-5"
      />

      <LazyPagesAboutProfileQuote :data="page.data.director" />

      <LazyWidgetEmployees
        v-if="page.data.employs"
        class="mb-12 mb-md-20 pb-3 pb-md-20 border-bottom"
        :employees="page.data.employs"
        heading-level="h3"
      />

      <div
        v-if="pageLinks"
        id="pages"
        class="mb-12 mb-md-20 scroll-margin-top-5"
      >
        <Tracker :data="{ position: 'Tab' }">
          <LazyWidgetPagesTabs
            :links="pageLinks"
            :data="page.data.pages"
            :select-label="$t('Kategória')"
          />
        </Tracker>
      </div>

      <div
        v-if="page.data.banner"
        class="mb-12 mb-md-20 pb-12 pb-md-20 border-bottom"
      >
        <LazyBanner
          :data="page.data.banner"
          heading-level="h3"
        >
          <template
            v-if="page.data.banner.tag.background && page.data.banner.tag.name"
            #tag
          >
            <Label
              :text-color="page.data.banner.tag.color"
              :label="page.data.banner.tag.name"
              :background-color="page.data.banner.tag.background"
            />
          </template>
        </LazyBanner>
      </div>

      <LazyWidgetSocials
        class="mb-12 mb-md-20"
        :data="page.data.social"
      />

      <div class="pt-12 pt-md-20 border-top">
        <LazyWidgetHelpdeskExt />
      </div>
    </ContainerFluid>
    <IconsWrapper>
      <IconsSymbolQuotes />
    </IconsWrapper>
  </article>
</template>
